import React from 'react';

import UserSolicitationTable from '../Table';

import { useStyles } from './styles';

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <UserSolicitationTable />
    </div>
  );
};
